// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/Invalid.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Checkbox } from '@sail/ui';
export const Invalid = () => {
  return <Checkbox label="This Checkbox is in an invalid state." invalid />;
};